export enum FiscalizationType {
  SWEDEN = "SWEDEN",
  FINLAND = "FINLAND",
}
